import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../lib/helpers';

interface RequiredTemplateProps {
  /**
   * If component position should be absolute
   */
  absolute?: boolean;
  /**
   * If required label is icon
   */
  isIcon?: boolean;
  /**
   * Additional container classes
   */
  additionalClasses?: string;
  /**
   * Component test id
   */
  testId?: string;
}

const RequiredTemplate = ({
  absolute = false,
  isIcon = true,
  additionalClasses = '',
  testId = '',
}: RequiredTemplateProps) => {
  return (
    <span
      className={twMerge(
        'text-red text-sm leading-none select-none z-10 ml-1',
        absolute && 'absolute top-5',
        absolute && isIcon ? 'right-2' : 'right-3',
        additionalClasses,
      )}
      {...getTestProps(testId, 'required-template')}
    >
      *
    </span>
  );
};

export default RequiredTemplate;
